import keyMirror from 'utils/keyMirror';

/**
 * @constant {Object} ApplicationConstants
 * @memberof Application
 */
export const WorkflowConstants = keyMirror({
  CHECKIN_ACTION: undefined,
  NEXT_ACTION: undefined,
  PREVIOUS_ACTION: undefined,
  GET_BANK_DETAILS: undefined,
  GET_IP_ADDRESS: undefined,
  GET_KEY_ACTION: undefined,
  GET_TEST_VALUES_DATA: undefined,
  RESUME_APPLICATION: undefined,
  GET_AUTOPAY_DRAFTS: undefined,
});
